/* Adikopas - angliski uzrasai laukeliams, dydzio pagalbai ir dydziu lenteliu langas */
(function () {
  var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
  if (lang.indexOf('en') !== 0) return;

  var EXACT = {
    'Numeris': 'Number',
    'Marškinėlių vardas': 'Name on the jersey',
    'Marškinėlių ilgio pastaba': 'Jersey length note',
    'Ūgis (cm)': 'Height (cm)',
    'Nežinai dydžio? Įrašyk ūgį': 'Not sure about the size? Enter your height',
    'Dydžių lentelė': 'Size chart',
    'Taip atrodys jūsų užrašas': 'This is how your print will look',
    'PAVARDĖ': 'SURNAME',
    'Uždaryti': 'Close',
    'Ilgis vienodas, skiriasi apimtimi — jei nori laisviau, rinkis didesnį.': 'The length is the same, the width differs — choose the larger size for a looser fit.',
    'Numeris bus išsaugotas kartu su jūsų užsakymu.': 'The number is saved with your order.',
    'Vardas bus išsaugotas kartu su jūsų užsakymu.': 'The name is saved with your order.'
  };

  var PREFIX = [
    ['Įveskite numerį tiksliai taip', 'Enter the number exactly as it should appear on the garment. Leave the field empty if you do not need one.'],
    ['Įveskite vardą tiksliai taip', 'Enter the name exactly as it should appear on the garment. Leave the field empty if you do not need one.'],
    ['Marškinėlius galime pailginti', 'We can make the jersey 3 cm longer or shorter. Write it here if you need that; otherwise leave the field empty.'],
    ['Suaugusiųjų dydžiai siuvami', 'Adult sizes are made in several leg lengths, so we need to know your height. Enter it in centimetres, e.g. 182. For kids sizes enter the height of the child.'],
    ['Pagal ūgį siūlome dydį', 'Based on your height we suggest size'],
    ['Pagal ūgį tinka', 'Based on your height these fit'],
    ['Tikslaus atitikmens nėra', 'There is no exact match — the closest size is'],
    ['Pasirinkti ', 'Choose '],
    ['Pagaminimas: ', 'Production: ']
  ];

  var TAIL = [['darbo dienų', 'business days'], ['darbo dienos', 'business days']];

  function tail(s) {
    TAIL.forEach(function (p) { s = s.split(p[0]).join(p[1]); });
    return s;
  }

  function translate(raw) {
    var t = (raw || '').trim();
    if (!t) return null;
    if (EXACT[t] !== undefined) return EXACT[t];
    for (var i = 0; i < PREFIX.length; i++) {
      if (t.indexOf(PREFIX[i][0]) === 0) {
        var rest = t.slice(PREFIX[i][0].length);
        if (PREFIX[i][0].charAt(PREFIX[i][0].length - 1) === ' ' || /^[\s0-9]/.test(rest)) return PREFIX[i][1] + tail(rest);
        return PREFIX[i][1];
      }
    }
    return null;
  }

  var PH = {
    'pvz.: 23': 'e.g. 23',
    'pvz.: JONAITIS': 'e.g. SMITH',
    'pvz.: 182': 'e.g. 182',
    'pvz.: pailginti 3 cm': 'e.g. 3 cm longer'
  };

  function sweep() {
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n, jobs = [];
    while ((n = w.nextNode())) {
      if (n.parentNode && /^(SCRIPT|STYLE)$/.test(n.parentNode.nodeName)) continue;
      var out = translate(n.nodeValue);
      if (out !== null && out !== n.nodeValue.trim()) jobs.push([n, out]);
    }
    jobs.forEach(function (j) { j[0].nodeValue = j[0].nodeValue.replace(j[0].nodeValue.trim(), j[1]); });

    [].forEach.call(document.querySelectorAll('input[placeholder], textarea[placeholder]'), function (el) {
      var p = el.getAttribute('placeholder');
      if (PH[p]) el.setAttribute('placeholder', PH[p]);
    });
    [].forEach.call(document.querySelectorAll('[aria-label]'), function (el) {
      var a = el.getAttribute('aria-label');
      if (EXACT[a]) el.setAttribute('aria-label', EXACT[a]);
    });
  }

  /* vardo perziuros plokstele: temos skriptas ja perpiesia po kiekvieno ivedimo,
     todel pavyzdini uzrasa taisome atskirai ir sekame ta viena elementa */
  function plate() {
    var el = document.querySelector('.adk-plate__name');
    if (!el) return;
    if (el.textContent.trim() === 'PAVARDĖ') el.textContent = 'SURNAME';
    if (!el.getAttribute('data-adk-en')) {
      el.setAttribute('data-adk-en', '1');
      new MutationObserver(function () {
        if (el.textContent.trim() === 'PAVARDĖ') el.textContent = 'SURNAME';
      }).observe(el, { childList: true, characterData: true, subtree: true });
    }
  }

  function isHeading(el) { return /^H[2-4]$/.test(el.tagName); }

  function hasTable(h) {
    var n = h.nextElementSibling;
    while (n && !isHeading(n)) {
      if (n.tagName === 'TABLE' || (n.querySelector && n.querySelector('table'))) return true;
      n = n.nextElementSibling;
    }
    return false;
  }

  function chart() {
    if (document.querySelector('.adk-modal')) return;
    var hs = [].slice.call(document.querySelectorAll('h2, h3, h4')).filter(hasTable);
    if (!hs.length) return;

    var box = document.createElement('div');
    box.className = 'adk-modal__box';
    box.innerHTML = '<button type="button" class="adk-modal__close" aria-label="Close">&times;</button>';
    hs.forEach(function (h) {
      var n = h.nextElementSibling, chunk = [h];
      while (n && !isHeading(n)) { chunk.push(n); n = n.nextElementSibling; }
      chunk.forEach(function (el) { box.appendChild(el); });
    });

    var modal = document.createElement('div');
    modal.className = 'adk-modal';
    modal.appendChild(box);
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('adk-modal__close')) modal.removeAttribute('open');
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') modal.removeAttribute('open'); });
    document.body.appendChild(modal);

    var sel = [].slice.call(document.querySelectorAll('select')).filter(function (el) {
      return /dydis|size/i.test(el.name || '');
    })[0];
    var host = null, p = sel ? sel.parentElement : null;
    for (var i = 0; i < 4 && p && !host; i++) {
      var lab = p.querySelector('label, legend');
      if (lab) host = lab;
      p = p.parentElement;
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'adk-size-btn';
    btn.textContent = 'Size chart';
    btn.addEventListener('click', function () { modal.setAttribute('open', ''); });

    if (host) {
      host.classList.add('adk-size-row');
      host.appendChild(btn);
    } else {
      var bb = document.querySelector('buy-buttons-component, [class*=buy-buttons]');
      if (!bb) return;
      var w2 = document.createElement('div');
      w2.style.margin = '2px 0';
      w2.appendChild(btn);
      bb.parentNode.insertBefore(w2, bb);
    }
  }

  function run() { try { sweep(); plate(); chart(); } catch (e) {} }

  /* pirmas paleidimas is karto, po to ne dazniau kaip kas 400 ms */
  var last = 0, timer = 0;
  function schedule() {
    var now = Date.now();
    if (now - last > 400) { last = now; run(); return; }
    clearTimeout(timer);
    timer = setTimeout(function () { last = Date.now(); run(); }, 400);
  }
  schedule();
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('input', schedule, true);
  document.addEventListener('change', schedule, true);
  [600, 1500, 3000].forEach(function (ms) { setTimeout(run, ms); });
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();